export default {
    /**
     * 设置图片host
     */
    SET_HOST: 'SET_HOST',
    /**
     * 用户登录
     */
    LOGIN: 'LOGIN',
    /**
     * 设置自定义字段
     */
    SET_DISPLAY_CONF: 'SET_DISPLAY_CONF',
    /**
     * 设置页面基础数据
     */
    SET_PAGE_DATA: 'SET_PAGE_DATA',
    /**
     * 设置安全距离
     */
    SET_SAFE_TOP_AND_BOTTOM: 'SET_SAFE_TOP_AND_BOTTOM',
    /**
     * 设置PV状态
     */
    SET_PV_STATUS: 'SET_PV_STATUS',
    /**
     * 设置app版本
     */
    SET_APP_VERSION: 'SET_APP_VERSION',
    /**
     * 设置当前页生效组件信息
     */
    SET_COMPONENT_LIST: 'SET_COMPONENT_LIST',
    /**
     * 设置当前页面显示状态
     */
    SET_CURRENT_PAGE_STATUS: 'SET_CURRENT_PAGE_STATUS',
    /**
     * 有关闭挽留模块
     */
    SET_CLOSE_STAY_MODULE: 'HIDE_DEFAULT_BACK_BUTTON',
    /**
     * 设置顶部分享按钮
     */
    SET_TOP_BAR_SHARE_BUTTON_DATA: 'SET_TOP_BAR_SHARE_BUTTON_DATA',
    /**
     * 设置发现页位移量
     * 目前有三个情况：
     * 位置为1的图片模块
     * 位置为1的视频模块
     * 位置为1并且被隐藏的筛选分页模块
     */
    SET_FIND_TAB_TRANSLATE: 'SET_FIND_TAB_TRANSLATE',
    /**
     * 设置是否需要首次展示头图
     */
    SET_NEED_FIRST_SHOW_TITLE_IMG: 'SET_NEED_FIRST_SHOW_TITLE_IMG',
    /**
     * 设置是否已经首次展示头图
     */
    SET_HAS_FIRST_SHOW_TITLE_IMG: 'SET_HAS_FIRST_SHOW_TITLE_IMG',
    /**
     * 设置头图模块初始化流程完成
     */
    SET_TITLE_IMG_MODULE_PROCESS_FINISHED: 'SET_TITLE_IMG_MODULE_PROCESS_FINISHED',
    /**
     * 设置允许重复任务自动领奖
     */
    SET_ALLOW_REPEAT_TASK_AUTO_OBTAIN_PRIZE: 'SET_ALLOW_REPEAT_TASK_AUTO_OBTAIN_PRIZE',
    /**
     * 设置大类容器已经可见过
     */
    SET_FINDLIKE_CONTAINER_HAS_VISIBLE: 'SET_FINDLIKE_CONTAINER_HAS_VISIBLE',
    /**
     * 设置优先级处理以及开始
     */
    SET_PRIORITY_PROCESSING_START: 'SET_PRIORITY_PROCESSING_START',
    /**
     * 设置活动名称（activityEngine/entry 返回，用于投票模块曝光埋点及弹窗展示）
     */
    SET_ACTIVITY_NAME: 'SET_ACTIVITY_NAME',
};
